import {
  IApplicantAccountingCreatePayload,
  IApplicantAccountingListResponse,
  IApplicantAccountingUpdatePayload,
  IApplicantInfoCreatePayload,
  IApplicantInfoDetail,
  IApplicantInfoListItem,
  IApplicantInfoPayload,
} from "@/src/types/officeAccounting";
import { apiType } from "./apiType";

/** Response shape for GET /applicant-info/list and /applicant-info/search/filter. */
export interface IOfficeAccountingListResponse {
  data?: IApplicantInfoListItem[];
  count?: number;
}

const buildListParams = (limit: string, offset: number, office: string) => ({
  limit,
  offset,
  office,
});

/** GET /applicant-info/list — как Online applications (limit, offset, office). */
export const officeAccountingPageRequests = {
  getList: async (limit: string, offset: number, office: string) => {
    try {
      return await apiType.main.get<IOfficeAccountingListResponse>("/applicant-info/list", buildListParams(limit, offset, office));
    } catch (error) {
      console.log("Office Accounting getList error:", error);
      return null;
    }
  },

  /** GET /applicant-accounting/list */
  getApplicantAccountingList: async (limit: string, offset: number, office: string) => {
    try {
      return await apiType.main.get<IApplicantAccountingListResponse>(
        "/applicant-accounting/list",
        buildListParams(limit, offset, office),
      );
    } catch (error) {
      console.log("Office Accounting getApplicantAccountingList error:", error);
      return null;
    }
  },

  /** GET /applicant-info/search/filter — query, limit, offset, office в query. */
  searchFilter: async (limit: string, offset: number, office: string, query: string) => {
    try {
      return await apiType.main.get<IOfficeAccountingListResponse>("/applicant-info/search/filter", {
        ...buildListParams(limit, offset, office),
        query,
      });
    } catch (error) {
      console.log("Office Accounting searchFilter error:", error);
      return null;
    }
  },

  getByStudentInfoId: async (studentInfoId: number | string) => {
    try {
      return await apiType.main.get<IApplicantInfoDetail>(`/applicant-info/${studentInfoId}`);
    } catch (error) {
      console.log("Office Accounting getByStudentInfoId error:", error);
      return null;
    }
  },

  /** Reserved — not used in UI yet. */
  create: async (data: IApplicantInfoCreatePayload) => {
    try {
      await apiType.main.post("/applicant-info/create", data);
      return true;
    } catch (error) {
      console.log("Office Accounting create error:", error);
      return false;
    }
  },

  /** POST /applicant-accounting/create — Document Check approve → Office Accounting row. */
  createApplicantAccounting: async (data: IApplicantAccountingCreatePayload) => {
    try {
      await apiType.main.post("/applicant-accounting/create", data);
      return true;
    } catch (error) {
      console.log("Office Accounting createApplicantAccounting error:", error);
      return false;
    }
  },

  update: async (studentInfoId: number | string, data: IApplicantInfoPayload) => {
    try {
      return await apiType.main.put<IApplicantInfoDetail>(`/applicant-info/update/${studentInfoId}`, data, {
        params: { student_info_id: studentInfoId },
      });
    } catch (error) {
      console.log("Office Accounting update error:", error);
      return null;
    }
  },

  /** PUT /applicant-accounting/update — id передаётся в теле запроса. */
  updateApplicantAccounting: async (accountingId: number | string, data: IApplicantAccountingUpdatePayload) => {
    try {
      const parsedId = Number(accountingId);
      return await apiType.main.put("/applicant-accounting/update", {
        id: Number.isFinite(parsedId) ? parsedId : accountingId,
        ...data,
      });
    } catch (error) {
      console.log("Office Accounting updateApplicantAccounting error:", error);
      return null;
    }
  },

  delete: async (studentInfoId: number | string) => {
    try {
      await apiType.main.delete(`/applicant-info/delete/${studentInfoId}`, undefined, {
        params: { student_info_id: studentInfoId },
      });
      return true;
    } catch (error) {
      console.log("Office Accounting delete error:", error);
      return false;
    }
  },
};
